<template>
  <div class="demo">
    <div class="demo_top">
      <div>sdfsdf</div>
      <div>sdfsdfasedw2q</div>
      <div>sdfsdfasedw2qawsedwadq</div>
      <div>sdfs</div>
      <div>sdfssad</div>
      <div>sdfssadasedas</div>
      <div>sdf</div>
      <div>sdfawsdasdas</div>
      <div>sdfawsdasdassadasdsd</div>
      <div>sdfsdff</div>
      <div>sdfsdffsaddfsfsdfsdfsdfsfsdfsdfsdfsd</div>
      <div>sdfsdffsaddfsfsdfssdfsdf</div>
      <div>sdfsdffsadd</div>
      <div>sdfsdf</div>
      <div>sdfsdsdfsdfsdfsfsdf</div>
      <div>sdfsd</div>
      <div>sdfsdfsdfsdfsdf</div>
      <div>s</div>
      <div>ssdf</div>
      <div>ssdfasdfsfsdfs</div>
      <div>sdsf</div>
      <div>sdsfdsfrdsfsd</div>
      <div>sdsfdsfrdsfsdsdfrsfsdfsdfdsfsdfsdf</div>
      <div>fsdfdfsfwe</div>
      <div>dfsdfsafrw</div>
      <div>dfsdfsafrw</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  mounted() {
    let name = this.$route.query.name
    if (this.$route.query.r == 1) {
      localStorage.setItem('isSelect', '我的关注')
      this.$router.push('./follow')
    } else if (this.$route.query.r == 2) {
      localStorage.setItem('isSelect', '邮箱建联')
      localStorage.setItem('isemitco', '收件箱')
      this.$router.push('./inbox')
    } else if (this.$route.query.r == 3) {
      localStorage.setItem('isSelect', '邮箱建联')
      localStorage.setItem('isemitco', '发件箱')
      this.$router.push('./outbox')
    } else if (this.$route.query.r == 4) {
      localStorage.setItem('isSelect', '邮箱建联')
      localStorage.setItem('isemitco', '发件箱')
      this.$router.push({ path: './outbox', query: { name: name } })
    } else if (this.$route.query.r == 5) {
      this.$router.push('./outbox')
    } else if (this.$route.query.r == 6) {
      this.$router.push('./info')
      localStorage.setItem('isSelect','-1')
    } else if (this.$route.query.r == 7) {
      this.$router.push('./authorization')
      localStorage.setItem('isSelect', '多平台管理')
      localStorage.setItem('isemitco', '授权中心')
    }
  }
}
</script>
<style lang="less" scoped>
.demo_top{
  background: #fff;
  margin-left: 500px;
  width: 300px;
  text-align: center;
  div{
    display: inline-block;
    margin: 5px 10px;
    color: #8280FF;
  }
}
</style>